export const hasEntryEnoughEmployees = ({
  present,
  ordered,
}: {
  present: number | null;
  ordered: number | null;
}) => {
  if (present == null || ordered == null) {
    return true;
  }
  return present >= ordered;
};
